import React, { useState, useEffect, useContext } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Typography } from "@mui/material";
import { UserContext, getCurrentToken } from "./context/UserContext";
import { useNavigate } from "react-router-dom";
import requests from "./base";
import swal from "sweetalert";
import ActionDropdown from "./ActionDropdown ";

const SalesDetailPanel = ({ orderId }) => {
  const [sales, setSales] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        const response = await requests.get(
          `/getSalesByOrderID?orderID=${orderId}`
        );
        const salesData = response.Data || [];
        setSales(salesData);
        const total = salesData.reduce(
          (sum, item) => sum + parseFloat(item.Amount || 0),
          0
        );
        setTotalAmount(total);
      } catch (error) {
        console.error("Failed to fetch sales:", error);
        setSales([]);
      }
    };

    fetchSalesData();
  }, [orderId]);

  return (
    <Box sx={{
      p: 2,
      backgroundColor: "#f5f5f5",
      borderRadius: 2,
     
      width: "100%",
      height: "100%",
    }}>

<Typography sx={{ fontWeight: "bold" }}>
                    Order Items
                  </Typography>
       <Box sx={{
        borderRadius: 2,
       display:"FLEX",
     
      }}>

    {sales ? (
  sales.length > 0 ? (
    sales.map((item, idx) => {
      const isService = item.ServiceId > 0;
      const bgColor = isService ? "#e0f7fa" : "#e3f2fd";
      const borderColor = isService ? "#0288d1" : "#00253d";

      return (
        <Box
          key={idx}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: bgColor,
            borderLeft: `6px solid ${borderColor}`,
            padding: 1.5,
            borderRadius: 1,
            mb: 1,
            margin: "5px",
            boxShadow: 1,
          }}
        >
          <Box>
        <Typography sx={{ fontWeight: "bold", color: borderColor }}>
          {isService
            ? `Service: ${item.ServiceName}`
            : `Product: ${item.ProductName}`}
        </Typography>

        {!isService && item.Quantity > 0 && (
          <Typography variant="body2">Qty: {item.Quantity}</Typography>
        )}

        {isService && item.ServiceDate && (
          <Typography variant="body2">
            appointment Date:{" "}
            {new Date(item.ServiceDate).toLocaleDateString("en-GB")}
          </Typography>
        )}

        <Typography variant="body2" sx={{ marginTop: 1 }}>
          Ksh. {parseFloat(item.Amount || 0).toFixed(2)}
        </Typography>
      </Box>
        </Box>
      );
    })
  ) : (
    <Typography variant="body2">No sales data found.</Typography>
  )
) : (
  <Typography variant="body2">Loading sales...</Typography>
)}

    </Box>
    </Box>
  );
};

const Orders = () => {
  const { signOut } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [vendorData, setVendorSale] = useState([]);
  const [token, setToken] = useState("");

  useEffect(() => {
    const tokenResponse = getCurrentToken();
    if (!tokenResponse) {
      navigate("/login");
    } else {
      const userToken = tokenResponse.Data.Token;
      setToken(userToken);
      fetchVendorSales(userToken);
    }
  }, []);

  const fetchVendorSales = async (userToken = token) => {
  setLoading(true); // optional: show loading on refresh
  try {
    const vendorID = getCurrentToken().Data.UserId;

    const response = await requests.get(
      `/getvendorSalesbyvendorID?vendorid=${vendorID}`
    );
    const vendorSales = response.Data || [];

    const updatedSales = await Promise.all(
      vendorSales.map(async (order) => {
        const salesResponse = await requests.get(
          `/getSalesByOrderID?orderID=${order.ID}`
        );
        const salesData = salesResponse.Data || [];
        const totalAmount = salesData.reduce(
          (sum, item) => sum + parseFloat(item.Amount || 0),
          0
        );
        return { ...order, TotalAmount: totalAmount, TotalItems: salesData.length };
      })
    );

    setVendorSale(updatedSales);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    setLoading(false);
  }
};


  const columns = [
    {
      accessorKey: "Description",
      header: "Order No",
      Cell: ({ row }) => {
        const description = row.original.Description;
        const totalItems = row.original.TotalItems || 0; // fallback if missing
        return (
          <Box>
            <Typography variant="body1" fontWeight="bold">
              {description}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {totalItems} item{totalItems !== 1 ? "s" : ""}
            </Typography>
          </Box>
        );
      },
    },

    {
      accessorKey: "OrderStatus",
      header: "Status",
      Cell: ({ cell }) => {
        const status = cell.getValue();

        let iconClass = "";
        let bgColor = "";
        let textColor = "";

        if (status === "Pending") {
          iconClass = "mdi mdi-clock-outline";
          bgColor = "#FFF9E6";
          textColor = "#C77800";
        } else if (status === "Delivered") {
          iconClass = "mdi mdi-check";
          bgColor = "#E6F9EC";
          textColor = "#007E33";
        } else if (status === "Canceled") {
          iconClass = "mdi mdi-close";
          bgColor = "#FCEBEC";
          textColor = "#D32F2F";
        } else if (status === "Processing") {
          iconClass = "mdi mdi-clock-outline";
          bgColor = "#E6F1FF";
          textColor = "#1565C0";
        } else if (status === "Returned") {
          iconClass = "mdi mdi-clock-outline";
          bgColor = "#E6F1FF";
          textColor = "#0D1B2A";
        }

        return (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              backgroundColor: bgColor,
              color: textColor,
              px: 1.5,
              py: 0.5,
              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            <span className={iconClass} style={{ fontSize: "18px" }}></span>
            {status}
          </Box>
        );
      },
    },

    {
      accessorKey: "ClientName",
      header: "Clent Name"
    },

    {
      accessorKey: "CreatedDate",
      header: "Date Ordered",
      Cell: ({ cell }) => {
        const rawDate = cell.getValue();
        const date = new Date(rawDate);
        const formatted = date.toLocaleDateString("en-GB", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        return formatted;
      },
    },

    {
      accessorKey: "TotalAmount",
      header: "Total Amount",
      Cell: ({ cell }) => `Ksh${parseFloat(cell.getValue()).toFixed(2)}`, // currency format
    },
    {
      header: "Update Status",
      id: "actions",
      Cell: ({ row }) => <ActionDropdown orderId={row.original.ID} onStatusUpdated={fetchVendorSales}/>,
    },
  ];

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <Box className="container mt-4">
      <Box>
        <MaterialReactTable
          columns={columns}
          data={vendorData}
          enablePagination
          enableRowHover
          enableColumnResizing
          enableSorting
          muiTableContainerProps={{ sx: { maxHeight: "auto" } }}
          muiTableBodyCellProps={{ sx: { fontSize: "14px" } }}
          enableExpandAll={false}
          renderDetailPanel={({ row }) => (
            <Box sx={{ height: "100%", width: "100%" }}>
              <SalesDetailPanel orderId={row.original.ID} />
            </Box>
          )}
        />
      </Box>
    </Box>
  );
};

export default Orders;
